import { useMutation } from "@apollo/client";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import { UPDATE_BANK } from "../../../../graphql/mutations";

export default function EditDialog({ open, handleClose, onEdit, data }) {

    // Setting mutation
    const [updateBank, { loading }] = useMutation(UPDATE_BANK);

    // Setting Formik
    const { handleSubmit, handleChange, setFieldValue, values, errors, resetForm } = useFormik({
        initialValues: { name: "", id: 0, code: 0 },
        onSubmit: (values) => {

            // Chamando a mutation de edição
            updateBank({
                variables: {
                    id: values.id,
                    name: values.name,
                    code: values.code
                }
            }).then(() => {
                onEdit();
            })

        }
    });
    
    useEffect(function () {
        if (data) {
            resetForm();
            setFieldValue('id', data.id);
            setFieldValue('code', data.id);
            setFieldValue('name', data.name);
        }
    }, [data]);
    
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="scroll-dialog-title">Editar Banco</DialogTitle>

                <DialogContent style={{padding: 16}}>

                    <TextField
                        variant="outlined"
                        margin="normal"
                        type="number"
                        onChange={handleChange}
                        value={values.code}
                        required
                        fullWidth
                        id="code"
                        label="Código"
                        name="code"
                        autoFocus
                        error={errors.code && true}
                        helperText={errors.code}
                    />

                    <TextField
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        value={values.name}
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoFocus
                        error={errors.name && true}
                        helperText={errors.name}
                    />

                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} variant="contained" color="primary" disabled={values.name == "" || loading}>
                        {loading && <CircularProgress size={14} style={{ marginRight: 12 }} />}
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
